import React from 'react';
import propTypes from 'prop-types';
import Anchor from './Anchor';
import closeAllNav from '../../../helpers/closeAllNav';

const Logo = props => {

	const { logo,  altText, logoClass, path } = props;

	let thisLogo = '';

	if (logo === 'logoLight') {
		thisLogo = '/images/logos/logo-light.svg';
	} else {
		thisLogo = '/images/logos/logo-dark.svg';
	}

	return(
		<Anchor internal anchorClass={'logo-link'} path={path}>
			<img src={thisLogo} alt={altText} className={logoClass} onClick={() => closeAllNav('(max-width: 2400px)')
			& window.scrollTo(0,0)} />
		</Anchor>
	)
};

Logo.propTypes = {
	logo: propTypes.string.isRequired,
	altText: propTypes.string.isRequired,
	logoClass: propTypes.string
};

export default Logo;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/objects/Logo.js